export interface ProductBrand {
  id: number;
  name: string;
  slug: string;
}

export const productBrandFromResponse = (responseData: any): ProductBrand => ({
  id: responseData.id,
  name: responseData.name,
  slug: responseData.slug,
});
